import { render, staticRenderFns } from "./SalesPromotion.vue?vue&type=template&id=3d3a5f73&scoped=true"
import script from "./SalesPromotion.vue?vue&type=script&lang=ts"
export * from "./SalesPromotion.vue?vue&type=script&lang=ts"
import style0 from "./SalesPromotion.vue?vue&type=style&index=0&id=3d3a5f73&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3a5f73",
  null
  
)

export default component.exports